import React, {useEffect, useState, useRef} from "react";
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import '../../css/cover.css';
import '../../css/styles.css';
import Report from "./Report";
import api from "../../api";
import IranFlag from "../../assets/images/iran.webp";
import {Datepicker} from '@ijavad805/react-datepicker';
import moment from 'moment-jalaali';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import LoadingSpinner from "../Loading";
import {toast, ToastContainer} from "react-toastify";
import {now} from "jalali-moment";
import {p2e, e2p} from "../../utils/utils";

export default function List() {
    const [loading, setLoading] = useState(false);
    const [reports, setReports] = useState([]);
    const [filters, setFilters] = useState({
        status: '5',
        name: '',
        lastname: '',
        startDate: null,
        endDate: null,
        plateFirst: '',
        plateLetter: '',
        plateSecond: '',
        plateThird: '',
        mobileNumber: '',
        trackingCode: '',
        carModel: '',
    });
    const [paginationInfo, setPaginationInfo] = useState({currentPage: 1, lastPage: 1, total: 0});
    
    const plate = p2e(`${filters.plateFirst}${filters.plateLetter}${filters.plateSecond} ${filters.plateThird}`);
    
    async function handlePrintAll() {
        setLoading(true);
        try {
            const response = await api.get(`/repair-request/print-all`, {
                responseType: 'blob',
                params: {
                    status: parseInt(filters.status),
                    name: filters.name,
                    lastname: filters.lastname,
                    startDate: filters.startDate,
                    endDate: filters.endDate,
                    plate: plate,
                    mobileNumber: filters.mobileNumber,
                    trackingCode: filters.trackingCode,
                    carModel: filters.carModel,
                }
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `reports_${now()}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.log(error)
            toast.error(error.message)
        } finally {
            setLoading(false);
        }
    }
    
    async function handlePrintRawCortex(reportId) {
        setLoading(true);
        try {
            const response = await api.get(`/company/print-raw-cortex`, {
                responseType: 'blob',
            });
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `cortex_${reportId}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            toast.error(error.message)
        } finally {
            setLoading(false);
        }
    }
    
    
    const handlePageChange = (event, page) => {
        setPaginationInfo((prev) => ({...prev, currentPage: page}));
    };
    
    const fetchReports = async () => {
        setLoading(true);
        const params = {
            status: parseInt(filters.status),
            name: filters.name,
            lastname: filters.lastname,
            startDate: filters.startDate,
            endDate: filters.endDate,
            plate: plate,
            mobileNumber: filters.mobileNumber,
            trackingCode: filters.trackingCode,
            carModel: filters.carModel,
            page: paginationInfo.currentPage,
            perPage: 10,
        };
        try {
            const response = await api.get("/repair-request", {params});
            setReports(response.data.data);
            setPaginationInfo({
                currentPage: response.data.pagination.current_page,
                lastPage: response.data.pagination.last_page,
                total: response.data.pagination.total,
            });
        } catch (error) {
            toast.error(error.message)
        } finally {
            setLoading(false);
        }
    }
    
    useEffect(() => {
        setReports([]);
        setLoading(true);
        fetchReports();
    }, [filters, paginationInfo.currentPage]);
    
    const handleReset = () => {
        setFilters({
            status: '5',
            name: '',
            lastname: '',
            startDate: null,
            endDate: null,
            plateFirst: '',
            plateLetter: '',
            plateSecond: '',
            plateThird: '',
            mobileNumber: '',
            trackingCode: '',
            carModel: '',
        });
        fetchReports();
    };
    
    return (
        <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <div className="row">
                    <div className="col">
                        <div className="row pelak mx-auto mb-3">
                            <div className="col">
                                <div className="row g-0">
                                    <div className="col border-0 border-start my-auto">
                                        <p className="text-center">ایران</p>
                                        <div>
                                            <input
                                                className="border-0 text-center"
                                                type="text"
                                                placeholder="44"
                                                onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                                value={filters.plateThird}
                                                onChange={(e) => setFilters({...filters, plateThird: e.target.value})}
                                            />
                                        </div>
                                    </div>
                                    <div className="col my-auto">
                                        <input
                                            className="border-0 text-center"
                                            type="text"
                                            placeholder="123"
                                            onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                            value={filters.plateSecond}
                                            onChange={(e) => setFilters({...filters, plateSecond: e.target.value})}
                                        />
                                    </div>
                                    <div className="col my-auto">
                                        <input
                                            className="border-0 text-center my-auto"
                                            type="text"
                                            placeholder="ص"
                                            maxLength="1"
                                            value={filters.plateLetter}
                                            onChange={(e) => setFilters({...filters, plateLetter: e.target.value})}
                                        />
                                    </div>
                                    <div className="col my-auto">
                                        <input
                                            className="border-0 text-center"
                                            type="text"
                                            id="inputPelak"
                                            placeholder="12"
                                            onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                            value={filters.plateFirst}
                                            onChange={(e) => setFilters({...filters, plateFirst: e.target.value})}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-auto leftSide">
                                <div className="flag">
                                    <img src={IranFlag} alt="iran's flag"/>
                                </div>
                                <div className="iranText text-center">
                                    <p>I.R.</p>
                                    <p>IRAN</p>
                                </div>
                            </div>
                        </div>
                        <div className="card border-3 border-dark mb-4">
                            <div className="card-body">
                                <div className="row mb-4">
                                    <div className="col form-check">
                                        <input type="radio" id="hame" name="report" className="form-check-input"
                                               value="5" checked={filters.status === '5'}
                                               onChange={() => setFilters({...filters, status: '5'})}/>
                                        <label htmlFor="hame" className="form-check-label text-nowrap">همه</label>
                                    </div>
                                    <div className="col form-check">
                                        <input type="radio" id="paziresh" name="report"
                                               className="form-check-input" value="1" checked={filters.status === "1"}
                                               onChange={() => setFilters({...filters, status: '1'})}/>
                                        <label htmlFor="paziresh" className="form-check-label text-nowrap">پذیرش
                                            شده</label>
                                    </div>
                                    <div className="col form-check">
                                        <input type="radio" id="enseraf" name="report"
                                               className="form-check-input" value="3" checked={filters.status === '3'}
                                               onChange={() => setFilters({...filters, status: '3'})}/>
                                        <label htmlFor="enseraf"
                                               className="form-check-label text-nowrap">انصرافی</label>
                                    </div>
                                    <div className="col form-check">
                                        <input type="radio" id="tarkhis" name="report"
                                               className="form-check-input" value="4" checked={filters.status === '4'}
                                               onChange={() => setFilters({...filters, status: '4'})}/>
                                        <label htmlFor="tarkhis" className="form-check-label text-nowrap">ترخیص
                                            شده</label>
                                    </div>
                                    <div className="col form-check">
                                        <input type="radio" id="nobat" name="report"
                                               className="form-check-input" value="2" checked={filters.status === '2'}
                                               onChange={() => setFilters({...filters, status: '2'})}/>
                                        <label htmlFor="nobat" className="form-check-label text-nowrap">دارای
                                            نوبت</label>
                                    </div>
                                </div>
                                <div className="row justify-content-center mb-3">
                                    <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                        <div className="row mb-3">
                                            <div className="col w-100">
                                                <input type="text" name="name" className="form-control shadow"
                                                       placeholder="نام" value={filters.name}
                                                       onChange={e => setFilters({...filters, name: e.target.value})}/>
                                            </div>
                                            <div className="col">
                                                <input type="text" name="lastname" className="form-control shadow"
                                                       placeholder="نام خانوادگی" value={filters.lastname}
                                                       onChange={e => setFilters({...filters, lastname: e.target.value})}/>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col">
                                                <input type="text" name="car_model" className="form-control shadow"
                                                       placeholder="مدل ماشین" value={filters.carModel}
                                                       onChange={e => setFilters({...filters, carModel: e.target.value})}/>
                                            </div>
                                            <div className="col">
                                                <input type="text" name="mobile_number" className="form-control shadow"
                                                       placeholder="شماره موبایل" value={filters.mobileNumber}
                                                       onChange={e => setFilters({...filters, mobileNumber: e.target.value})}/>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col">
                                                <input type="text" name="trackingCode" className="form-control shadow"
                                                       placeholder="کد پیگیری" value={filters.trackingCode}
                                                       onChange={e => setFilters({...filters, trackingCode: e.target.value})}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                        <div className="row mb-4">
                                            <div className="col">
                                                <label htmlFor="start-date">تاریخ شروع</label>
                                                <Datepicker
                                                    id="start-date"
                                                    format={'YYYY-MM-DD'}
                                                    lang={'fa'}
                                                    label="تاریخ شروع"
                                                    placeholder="انتخاب تاریخ شروع"
                                                    onChange={(date) => setFilters({...filters, startDate: moment(date).format()})}
                                                />
                                            </div>
                                            <div className="col">
                                                <label htmlFor="end-date">تاریخ پایان</label>
                                                <Datepicker
                                                    id="end-date"
                                                    format={'YYYY-MM-DD'}
                                                    lang={'fa'}
                                                    label="تاریخ شروع"
                                                    placeholder="انتخاب تاریخ شروع"
                                                    onChange={(date) => setFilters({...filters, endDate: moment(date).format()})}
                                                />
                                            </div>
                                        </div>
                                        <div className="row justify-content-center">
                                            <div className="col">
                                                {/*<button className="btn btn-primary ms-1 mb-1" onClick={handleShowReports}>نمایش گزارشات</button>*/}
                                                <button className="btn bg-warning fw-bold ms-1 mb-1"
                                                        onClick={handlePrintAll}>پرینت گزارشات
                                                </button>
                                                <button className="btn fw-bold btn-secondary ms-1 mb-1"
                                                        onClick={handleReset}>پاک کردن
                                                </button>
                                                <button className="btn fw-bold btn-danger ms-1 mb-1"
                                                        onClick={handlePrintRawCortex}>برگه پذیرش
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" dir="ltr">
                                    <div className="mx-auto w-auto">
                                        <Stack spacing={2}>
                                            <Pagination
                                                count={paginationInfo.lastPage}
                                                page={paginationInfo.currentPage}
                                                onChange={handlePageChange}
                                                siblingCount={0}
                                                size="medium"
                                                color="standard"
                                                responsive={true}
                                            />
                                        </Stack>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            {loading ? <LoadingSpinner className="loading-spinner"/> : <div></div>}
                            <div className="mt-2">
                                <Report reportsData={reports}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
